import { SlotPermission } from '../../../medrefer-web-sdk/api/models';

export const getSlotLocalization = (slot: SlotPermission) => {
    if (slot == SlotPermission.PRIVATE) return 'newSlotForm:slot_private';
    if (slot == SlotPermission.PUBLIC) return 'newSlotForm:slot_public';
    return 'newSlotForm:slot_internal';
};
